import { useCallback, useEffect, useState } from "react";
import { SvgIcon } from "../SvgIcon";
import { ScrollUpContainer } from "./styles";

const ScrollToTop = () => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = useCallback(() => {
    const offsetFromTop = window.scrollY;
    setShowScroll(offsetFromTop > 350);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop, { passive: true });
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [checkScrollTop]);

  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!showScroll) return null;

  return (
    <ScrollUpContainer
      type="button"
      onClick={scrollUp}
      aria-label="Scroll to top"
    >
      <SvgIcon src="scroll-top.svg" alt="" width="20px" height="20px" />
    </ScrollUpContainer>
  );
};

export default ScrollToTop;
